// ======================================================================
// FILE: src/modules/wms/dashboard/components/PendingApprovalsCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Pending Approvals Card
// ======================================================================

import React from "react";

export default function PendingApprovalsCard({
  data = [],
}) {

  const rows = Array.isArray(data)
    ? data
    : [];

  return (

    <div className="card shadow-sm mb-4">

      <div className="card-header bg-white d-flex justify-content-between align-items-center">

        <h5 className="mb-0">
          Pending Approvals
        </h5>

        <span className="badge bg-warning text-dark">
          {rows.length} Pending
        </span>

      </div>

      <div className="table-responsive">

        <table className="table table-hover table-bordered align-middle mb-0">

          <thead className="table-light">

            <tr>

              <th>Work No</th>

              <th>Title</th>

              <th>Requested By</th>

              <th>Approver</th>

              <th className="text-center">
                Priority
              </th>

              <th className="text-center">
                Pending Since
              </th>

            </tr>

          </thead>

          <tbody>

            {rows.length === 0 ? (

              <tr>

                <td
                  colSpan="6"
                  className="text-center text-muted py-4"
                >
                  No pending approvals
                </td>

              </tr>

            ) : (

              rows.map((row, index) => (

                <tr
                  key={
                    row.workNo
                    || index
                  }
                  style={{
                    cursor: "pointer",
                  }}
                >

                  <td>
                    <strong>
                      {row.workNo || "—"}
                    </strong>
                  </td>

                  <td>
                    {row.title || "—"}
                  </td>

                  <td>
                    {row.requestedBy || "—"}
                  </td>

                  <td>
                    <strong>
                      {row.approver || "—"}
                    </strong>
                  </td>

                  <td className="text-center">

                    <span
                      className={
                        row.priority === "Critical"
                          ? "badge bg-danger"
                          : row.priority === "High"
                          ? "badge bg-warning text-dark"
                          : row.priority === "Low"
                          ? "badge bg-secondary"
                          : "badge bg-primary"
                      }
                    >
                      {row.priority || "—"}
                    </span>

                  </td>

                  <td className="text-center">
                    {row.age || "—"}
                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

  );
}